import { DialogRef } from '@agent-ds/shared/components/dialog/dialog-ref';
import { StudentAIInterviewType } from '@agent-ds/shared/enums';
import { StudentAIInterviewResult, StudentDetail } from '@agent-ds/shared/interfaces';
import { FormMeta, GroupMeta, Tab } from '@agent-ds/shared/models';
import { DialogService, DynamicFieldService, StudentApiService } from '@agent-ds/shared/services';
import { StudentGPSAcademicCreateDialogComponent } from '@agent-ds/student/components/student-gps-academic-create-dialog/student-gps-academic-create-dialog.component';
import { StudentGPSAcademicCSVDialogComponent } from '@agent-ds/student/components/student-gps-academic-csv-dialog/student-gps-academic-csv-dialog.component';
import { StudentGPSAcademicViewInfoDialogComponent } from '@agent-ds/student/components/student-gps-academic-view-info-dialog/student-gps-academic-view-info-dialog.component';
import { Component, forwardRef, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'ag-student-academic-tab',
  templateUrl: './student-academic-tab.component.html',
  styleUrls: ['./student-academic-tab.component.scss'],
  providers: [{ provide: Tab, useExisting: forwardRef(() => StudentAcademicTabComponent) }],
})
export class StudentAcademicTabComponent extends Tab implements OnInit {
  @ViewChild('examResultRegistrationGPS', { static: false }) examResultRegistrationGPSButton: TemplateRef<HTMLElement>;
  @ViewChild('examResultRegistrationPeopleX', { static: false }) examResultRegistrationPeopleXButton: TemplateRef<HTMLElement>;
  @Input() student: StudentDetail;
  @Input() readonly: boolean;

  private dialogRef: DialogRef;

  private aiInterviewSubscription: Subscription;
  private gpsResults: StudentAIInterviewResult[] = [];
  private peoplexResults: StudentAIInterviewResult[] = [];

  metadataTop: FormMeta;
  metadataAIInterview: FormMeta;
  metadataBottom: FormMeta;

  valid = true;

  constructor(
    private dynamicService: DynamicFieldService,
    private studentApiService: StudentApiService,
    private dialog: DialogService
  ) {
    super();
  }

  ngOnInit() {
    this.dynamicService.fieldUpdateEvent.subscribe(() => {
      this.metadataTop = {
        disabled: this.readonly,
        groups: [
          {
            title: '学歴',
            rows: [
              ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('student', 'lastAcademicRecord')),
              ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('student', 'academicFieldType')),
            ],
          },
          {
            title: '最終',
            class: 'form__group--no-title-border',
            rows: this.dynamicService.getFormRows(this.dynamicService.getDefinition('student', 'academicHistory1')),
          },
          {
            title: 'No.2',
            class: 'form__group--no-title-border form__group--no-margin title-mt-20',
            rows: this.dynamicService.getFormRows(this.dynamicService.getDefinition('student', 'academicHistory2')),
          },
          {
            title: 'No.3',
            class: 'form__group--no-title-border form__group--no-margin title-mt-20',
            rows: this.dynamicService.getFormRows(this.dynamicService.getDefinition('student', 'academicHistory3')),
          },
          {
            title: 'No.4',
            class: 'form__group--no-title-border form__group--no-margin title-mt-20',
            rows: this.dynamicService.getFormRows(this.dynamicService.getDefinition('student', 'academicHistory4')),
          },
          {
            title: 'No.5',
            class: 'form__group--no-title-border form__group--no-margin title-mt-20',
            rows: this.dynamicService.getFormRows(this.dynamicService.getDefinition('student', 'academicHistory5')),
          },
          {
            class: 'form__group--no-title-border form__group--no-margin mt-20',
            rows: [
              ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('student', 'universityLevel')),
              ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('student', 'academicCourseType')),
            ],
          },
          {
            title: '資格',
            rows: [],
          },
          {
            title: 'No.1',
            class: 'form__group--no-title-border form__group--no-margin',
            rows: this.dynamicService.getFormRows(this.dynamicService.getDefinition('student', 'certificate1')),
          },
          {
            title: 'No.2',
            class: 'form__group--no-title-border form__group--no-margin title-mt-20',
            rows: this.dynamicService.getFormRows(this.dynamicService.getDefinition('student', 'certificate2')),
          },
          {
            title: 'No.3',
            class: 'form__group--no-title-border form__group--no-margin title-mt-20',
            rows: this.dynamicService.getFormRows(this.dynamicService.getDefinition('student', 'certificate3')),
          },
          {
            title: 'No.4',
            class: 'form__group--no-title-border form__group--no-margin title-mt-20',
            rows: this.dynamicService.getFormRows(this.dynamicService.getDefinition('student', 'certificate4')),
          },
          {
            title: 'No.5',
            class: 'form__group--no-title-border form__group--no-margin title-mt-20',
            rows: this.dynamicService.getFormRows(this.dynamicService.getDefinition('student', 'certificate5')),
          },
          {
            class: 'mt-20',
            rows: this.dynamicService.getFormRows(this.dynamicService.getDefinition('student', 'otherSkill')),
          },
          {
            class: 'mt-20',
            rows: [
              ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('student', 'programmingC')),
              ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('student', 'programmingCPP')),
              ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('student', 'programmingCS')),
              ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('student', 'programmingHTML')),
              ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('student', 'programmingJava')),
              ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('student', 'programmingJS')),
              ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('student', 'programmingPerl')),
              ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('student', 'programmingPHP')),
              ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('student', 'programmingPython')),
              ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('student', 'programmingRuby')),
              ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('student', 'programmingVB')),
              ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('student', 'programmingGo')),
              ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('student', 'otherITSkills')),
            ],
          },
        ]
      };

      this.metadataAIInterview = {
        disabled: this.readonly,
        groups: []
      }

      this.metadataBottom = {
        disabled: this.readonly,
        groups: [
          {
            title: '語学',
            rows: [],
          },
          {
            title: 'No.1',
            class: 'form__group--no-title-border form__group--no-margin',
            rows: this.dynamicService.getFormRows(this.dynamicService.getDefinition('student', 'language1')),
          },
          {
            title: 'No.2',
            class: 'form__group--no-title-border form__group--no-margin title-mt-20',
            rows: this.dynamicService.getFormRows(this.dynamicService.getDefinition('student', 'language2')),
          },
          {
            title: 'No.3',
            class: 'form__group--no-title-border form__group--no-margin title-mt-20',
            rows: this.dynamicService.getFormRows(this.dynamicService.getDefinition('student', 'language3')),
          },
          {
            title: 'No.4',
            class: 'form__group--no-title-border form__group--no-margin title-mt-20',
            rows: this.dynamicService.getFormRows(this.dynamicService.getDefinition('student', 'language4')),
          },
          {
            title: 'No.5',
            class: 'form__group--no-title-border form__group--no-margin title-mt-20',
            rows: this.dynamicService.getFormRows(this.dynamicService.getDefinition('student', 'language5')),
          },
          {
            title: '特記事項',
            class: 'form__group--no-title-border form__group--no-margin title-mt-20',
            rows: this.dynamicService.getFormRows(this.dynamicService.getDefinition('student', 'generalRemarksForResume')),
          },
        ],
      };
    });
  }

  ngOnChanges(changes) {
    if (changes.student && this.student) {
      this.fetchStudentAIInterviewList();
    }
  }

  private fetchStudentAIInterviewList(): void {
    if (!this.student || !this.student.id) return;

    if (this.aiInterviewSubscription) {
      this.aiInterviewSubscription.unsubscribe();
      this.aiInterviewSubscription = null;
    }

    this.aiInterviewSubscription = this.studentApiService
      .getStudentAIInterviewEntries(this.student.id)
      .subscribe((results) => {
        this.gpsResults = results.filter(e => e.type === StudentAIInterviewType.GPS);
        this.peoplexResults = results.filter(e => e.type === StudentAIInterviewType.PEOPLEX);
        this.metadataAIInterview = this.buildAIInterviewFormMeta();
        this.metadataAIInterview = {
          ...this.buildAIInterviewFormMeta()
        }
      });
  }

  private buildAIInterviewFormMeta(): FormMeta {
    const baseGroup: GroupMeta = {
      toggleButtonLabel: '情報を表示',
      toggledButtonLabel: '情報を表示',
      class: 'form__group--green-title-border',
      collapsable: true,
      expanded: true,
      lockToggling: true,
      rows: [],
    };

    const createGroupMeta = (result): GroupMeta[] => result && result.map(
      (info, index) => ({
        ...baseGroup,
        collapsedTitle: `No.${index + 1}`,
        toggledButtonAction: () => {
          this.openAIInterviewViewInfoDialog(info, this.student)
        },
      })
    ) || [];

    const gpsGroupMeta: GroupMeta[] = createGroupMeta(this.gpsResults);
    const peoplexGroupMeta: GroupMeta[] = createGroupMeta(this.peoplexResults);

    return {
      disabled: this.readonly,
      initTouched: !this.readonly,
      groups: [
        {
          title: 'GPS',
          rows: [],
          injectToHeader: this.examResultRegistrationGPSButton,
        },
        ...gpsGroupMeta,
        {
          title: 'AI面談・AI面接対策',
          rows: [],
          injectToHeader: this.examResultRegistrationPeopleXButton,
        },
        ...peoplexGroupMeta
      ],
    };
  }

  save(): void {
    this.studentApiService.update(this.student.id, this.student).subscribe((res) => this.studentApiService.refreshEvent.emit());
  }

  registerExamResultGPS() {
    this.registerExamResultFor(StudentAIInterviewType.GPS);
  }

  registerExamResultPeopleX() {
    this.registerExamResultFor(StudentAIInterviewType.PEOPLEX);
  }

  importCSVGPS() {
    this.importCSV(StudentAIInterviewType.GPS);
  }

  importCSVPeopleX() {
    this.importCSV(StudentAIInterviewType.PEOPLEX);
  }

  importCSV(type: StudentAIInterviewType) {
    this.dialogRef = this.dialog.open(StudentGPSAcademicCSVDialogComponent, {
      data: { type: type, student: this.student },
    });
    let closeSubscription: Subscription;
    const unsubscribe = () => {
      if (closeSubscription) {
        closeSubscription.unsubscribe();
      }
    };
    closeSubscription = this.dialogRef.afterClosed.subscribe((res) => {
      this.dialogRef = null;
      // 閉じたタイミングで更新
      this.fetchStudentAIInterviewList();
      unsubscribe();
    });
  }

  registerExamResultFor(type: StudentAIInterviewType) {
    this.dialogRef = this.dialog.open(StudentGPSAcademicCreateDialogComponent, {
      data: { type: type, student: this.student },
    });
    let closeSubscription: Subscription;
    const unsubscribe = () => {
      if (closeSubscription) {
        closeSubscription.unsubscribe();
      }
    };
    closeSubscription = this.dialogRef.afterClosed.subscribe((res) => {
      this.dialogRef = null;
      // 閉じたタイミングで更新
      this.fetchStudentAIInterviewList();
      unsubscribe();
    });
  }

  openAIInterviewViewInfoDialog(info: StudentAIInterviewResult, student: StudentDetail) {
    this.dialogRef = this.dialog.open(StudentGPSAcademicViewInfoDialogComponent, {
      data: { info, student },
    });
    let closeSubscription: Subscription;
    const unsubscribe = () => {
      if (closeSubscription) {
        closeSubscription.unsubscribe();
      }
    };
    closeSubscription = this.dialogRef.afterClosed.subscribe((res) => {
      this.dialogRef = null;
      unsubscribe();
    });
  }
}
